import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Form } from '../interfaces/form-model';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {

  constructor(private http: HttpClient) { }

  getForm(id: string, takeForm?: boolean, disableEemailConfirmation?: boolean): Observable<Form> {

    let params = new HttpParams().set('_', new Date().getTime().toString());

    if (takeForm !== undefined) {
      params = params.set('takeForm', takeForm.toString());
    }

    if (disableEemailConfirmation !== undefined) {
      params = params.set('disable_email_confirmation', disableEemailConfirmation.toString());
    }

    return this.http.get<Form>(`${window.location.origin}/ui-forms/v1/form/${id}`, { params });
  }

  getFormRefresh(id: string, currentPage: number): Observable<Form> {
    const params = new HttpParams()
      .set("_", new Date().getTime().toString())
      .set("currentPage", currentPage);
    return this.http.get<Form>(`${window.location.origin}/ui-forms/v1/form/${id}`, { params });
  }

  getPage(id: string, currentPage: number, pageDirection: string): Observable<Form> {
    const params = new HttpParams()
      .set('_', new Date().getTime().toString())
      .set("currentPage", currentPage)
      .set("pageDirection", pageDirection);
    return this.http.get<Form>(`${window.location.origin}/ui-forms/v1/form/${id}`, { params })
      .pipe(map((formData: Form) => formData));
  }

  checkEmailExists(email: string) {

    let params = new HttpParams()
      .set('_', new Date().getTime().toString())
      .append('email', email);

    return this.http.get("/ui-forms/v1/checkEmail", { params });
  }

  createProspectProfile(email: string, password: string) {

    return this.http.post("/ui-forms/v1/prospectProfile", {
      email: email,
      password: password
    }, { responseType: 'text' })
  }
}
